import request from '@/utils/request'

//团队预约附件压缩包
export function getTeamZip(params) {
  return request({
    url: '/api/getTeamZip',
    method: 'get',
    params
  });
}

//团队门票预约
export function makeTeamAppointment(data) {
  return request({
    url: '/api/makeTeamAppointment',
    method: 'POST',
    data
  });
}

//团队门票预约查询
export function queryTeamAppointment(data) {
  return request({
    url: '/api/queryTeamAppointment',
    method: 'POST',
    data,
    'content-type': 'application/x-www-form-urlencoded'
  });
}




// WEBPACK FOOTER //
// ./src/api/teamAppoint/index.js